import { useUserState } from "portal-ui-remote/UserStateContext";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteLinkSettings = lazy(() => import("codat-auth-settings-ui/Link"));

const LinkSettings = () => {
  const userState = useUserState();

  return (
    <Page>
      <React.Suspense fallback={<PageLoadingSkeleton />}>
        <ErrorBoundary>
          <RemoteLinkSettings userState={userState.userState} useRouterV5 />
        </ErrorBoundary>
      </React.Suspense>
    </Page>
  );
};

export default LinkSettings;
